import { parsePhoneNumberFromString } from 'libphonenumber-js'
import { pathOr } from 'ramda'

import { PhoneNumber } from 'features/checkout/types'

// splitPhoneNumber :: String -> Object
export const splitPhoneNumber = (phoneNumber): any => {
  if (!phoneNumber) return {}

  const parsedPhoneNumber = parsePhoneNumberFromString(phoneNumber)

  if (!parsedPhoneNumber) {
    return {}
  }

  const prefix = `+${parsedPhoneNumber.countryCallingCode}`
  const cellPhone = parsedPhoneNumber.nationalNumber

  return { prefix, cellPhone }
}

// joinPhoneNumber :: Object -> String
export const joinPhoneNumber = (phoneNumber?: PhoneNumber): string =>
  `${pathOr('', ['prefix'], phoneNumber)}${pathOr('', ['cellPhone'], phoneNumber)}`
